import store from '@/store'

export function addAttributes(sessions) {
  let group = [];
  let overlappings = {};
  for (let i = 0; i < sessions.length; i++) {
    let session = sessions[i];
    let matching = true;
    if (store.state.filter.session_group.length && !store.state.filter.session_group.includes(session.session_group_id)) {
      matching = false;
    }
    if (store.state.filter.session_type.length && !store.state.filter.session_type.includes(session.session_type_id)) {
      matching = false;
    }
    if (store.state.filter.room.length && !store.state.filter.room.includes(session.room_id)) {
      matching = false;
    }
    session.matching = matching;
    if (session.type === null) {
      session.type = { value: { color: '#000000', background: '#ffffff' }};
    }
    let overlap = sessions.find(session => 
      session.id != session.id 
      && session.day_id === session.day_id 
      && session.room_id === session.room_id 
      && !(session.end_time_timestamp <= session.start_time_timestamp || session.start_time_timestamp >= session.end_time_timestamp)
    );
    if (overlap !== undefined) {
      if (!group.includes(overlap.id)) group.push(overlap.id);
      if (!group.includes(session.id)) group.push(session.id);
    } else {
      for (let j = 0; j < group.length; j++) overlappings[parseInt(group[j])] = group.length;
      group = [];
    }
    if ((i + 1) === sessions.length) {
      for (let j = 0; j < group.length; j++) overlappings[parseInt(group[j])] = group.length;
    }
  }
  for (let i = 0; i < sessions.length; i++) {
    let session = sessions[i];
    session.overlaps = Object.prototype.hasOwnProperty.call(overlappings, session.id)
      ? overlappings[session.id]
      : 1;
  }
  return sessions;
}
